import {
    ChangeDetectorRef, Component, ComponentFactoryResolver, Input, ViewChild,
    ViewContainerRef
} from "@angular/core";
import {CardTransferMenuIcon} from "../../../../../common/components/icons/card.transfer.menu.icon";
import {MenuIconI} from "./menu.item.metadata";

@Component({
    selector: 'tfl-menu-icon',
    entryComponents: [
        CardTransferMenuIcon
    ],
    template: require('./menu.icon.template.html')
})
export class MenuIcon {
    @Input('menu-icon') icon: MenuIconI;
    @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

    private _component: any;

    constructor(private _cd: ChangeDetectorRef,
                private _cfr: ComponentFactoryResolver) {
    }

    ngOnInit() {
        if (this.isComponentImage()) {
            setTimeout(() => {
                const factory = this._cfr.resolveComponentFactory(this.icon.componentImage.type);
                this._component = this.content.createComponent(factory, 0).instance;
                this._cd.detectChanges();
            });
        }
    }

    isComponentImage(): boolean {
        return !!this.icon.componentImage;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/menu/menu.icon.component.ts